var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Logo"),React.createElement("polyline",{"points":"0, 0 512, 0 512, 64 512, 128 0, 128 0, 64 0, 64","key":1}),React.createElement("polyline",{"points":"512, 512 0, 512 0, 448 0, 384 512, 384 512, 448 512, 448","key":2}),React.createElement("polyline",{"points":"0, 256 0, 512 128, 512 128, 256","key":3}),React.createElement("polyline",{"points":"512, 256 512, 0 384, 0 384, 256","key":4}),React.createElement("polyline",{"points":"256, 341.333 170.667, 341.333 170.667, 256 256, 170.667 341.333, 170.667 341.333, 256","key":5})]);
}

Icon.defaultProps = {"role":"img","viewBox":"0 0 512 512"};

module.exports = Icon;

Icon.default = Icon;
